'use strict';

module.exports = {
  date  : {
    formats : {
      de: require(__dirname + '/../resources/date_formats.de.json'),
      en: require(__dirname + '/../resources/date_formats.en.json'),
    },
    fallback: require(__dirname + '/../resources/date_formats.json'),
  },
  number: {
    formats : {
      de: require(__dirname + '/../resources/number_formats.de.json'),
      en: require(__dirname + '/../resources/number_formats.en.json'),
    },
    fallback: require(__dirname + '/../resources/number_formats.json'),
  },
};
